// ** Third Party Components
import styled from "styled-components";

// ** Custom Components
import Block from "components/layout/Block";

// #####################################################

export const StyledDropdownContainer = styled((props) => <Block {...props} />)`
	&:hover {
		background-color: ${({ theme: { isDarkMode } }) =>
			!isDarkMode
				? "var(--dz-ref-color-gray050)"
				: "var(--dz-sys-button-dropdown-background-color)"};
	}
`;

// #####################################################
